namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd6Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd6';
    }
}
